<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0">
      <WarningMessage
        class="text-center"
        :message="`Você está realizando o pagamento/recebimento de ${itemsSelected.length} lançamento(s).`"
      />
    </div>
    <div class="col-md-12 pt-0 pb-0" v-if="itemsSelected.length == 0">
      <WarningMessage
        class="text-center"
        :message="`Lançamento(s) selecionado(s) já está pago.`"
      />
    </div>
    <div
      class="col-md-6 pt-0 pb-0 d-flex align-items-center"
      v-if="itemsSelected.length > 0"
    >
      <b-form-checkbox id="effectuate" v-model="effectuate" name="effectuate">
        Efetivar na data de vencimento
      </b-form-checkbox>
    </div>
    <div
      class="col-md-6 pt-0 pb-0"
      v-if="!effectuate && itemsSelected.length > 0"
    >
      <label>Efetivado em</label>
      <input type="date" class="form-control" v-model="paid_in_date" />
    </div>
    <div class="col-md-12 pt-0 pb-0"></div>
    <div class="col-md-6 pt-0 pb-0" v-if="itemsSelected.length > 0">
      <label>Forma de pagamento</label>
      <select
        class="form-control"
        v-model="finance_configuration_payment_methods_id"
      >
        <option value="">SELECIONE...</option>
        <option
          v-for="(item, key) in finance_configuration_payment_methods"
          :key="key"
          :value="item.id"
        >
          {{ item.description }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0" v-if="itemsSelected.length > 0">
      <label>Conta</label>
      <select class="form-control" v-model="finance_configuration_account_id">
        <option value="">SELECIONE...</option>
        <option
          v-for="(item, key) in finance_configuration_account"
          :key="key"
          :value="item.id"
        >
          {{ item.account_nickname }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0" v-if="itemsSelected.length > 0">
      <label>Competência</label>
      <input type="date" class="form-control" v-model="competence" />
    </div>
    <div class="col-md-12 pb-0">
      <hr />
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <v-btn :disabled="loading" class="btn-cancel" @click="$emit('cancel')"
        >CANCELAR</v-btn
      >
    </div>
    <div class="col-md-6 pt-0 pb-0 text-right" v-if="itemsSelected.length > 0">
      <ConfirmationDialog
        :disabled="loading"
        :loading="loading"
        headerClass="modal-header-i"
        message-title="PAGAR/RECEBER?"
        :message-body="`Deseja realmente pagar/receber o(s) lançamento(s) selecionado(s)?`"
        open-class="btn-save"
        open-left-icon="fas fa-check"
        openText="PAGAR/RECEBER"
        @yes="handlePay"
      />
    </div>
  </div>
</template>

<script>
import WarningMessage from "../../../../Components/WarningMessage";

import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import { formatMoney } from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "PayMultiples",
  components: {
    WarningMessage,
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    itemsSelected: Array,
    finance_configuration_account: Array,
    finance_configuration_payment_methods: Array,
  },
  data() {
    return {
      paid_in_date: moment().format("YYYY-MM-DD"),
      finance_configuration_payment_methods_id: "",
      finance_configuration_account_id: "",
      competence: "",
      effectuate: false,
      errors: [],
      loading: false,
    };
  },
  methods: {
    formatMoney,
    async handlePay() {
      try {
        this.loading = true;

        const {
          itemsSelected,
          effectuate,
          paid_in_date,
          finance_configuration_payment_methods_id,
          finance_configuration_account_id,
          competence,
        } = this;

        let params = {
          itemsSelected,
          effectuate,
          paid_in_date,
          finance_configuration_payment_methods_id,
          finance_configuration_account_id,
          competence,
        };

        const response = await api.post(
          "/rest-home/financial/launch/finance-launch-bills-to-pay-installments/pay",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>